import React, { FC, PropsWithChildren, useState, useEffect } from 'react';
import classNames from 'classnames';
import { CommonEvent } from '@tarojs/components/types/common';
import View from '../view';

interface ICurtainProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 是否显示
   * @default false
   */
  visible?: boolean;
  /**
   * 关闭按钮位置
   * @default bottom
   */
  closeBtnPosition?: 'top' | 'top-left' | 'top-right' | 'bottom' | 'bottom-left' | 'bottom-right';
  /**
   * 点击关闭按钮时的回调函数
   */
  onClose?: () => void;
}

const Curtain: FC<PropsWithChildren<ICurtainProps>> = ({ children, className, visible: propsVisible = false, closeBtnPosition = 'bottom', onClose }) => {
  const [visible, setVisible] = useState(false);

  const curtainClass = classNames(
    {
      'ink-curtain': true,
    },
    className,
  );
  const btnCloseClass = classNames({
    'ink-curtain__btn-close': true,
    [`ink-curtain__btn-close--${closeBtnPosition}`]: closeBtnPosition,
  });

  const stopPropagation = (e: CommonEvent) => {
    e.stopPropagation();
  };

  const selfOnClose = (e: CommonEvent) => {
    e.stopPropagation();
    setVisible(false);
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    setVisible(propsVisible);
  }, [propsVisible]);

  return visible ? (
    <View className={curtainClass} onClick={stopPropagation}>
      <View className="ink-curtain__container">
        <View className="ink-curtain__body">
          {children}
          <View className={btnCloseClass} onClick={selfOnClose} />
        </View>
      </View>
    </View>
  ) : null;
};

export default Curtain;
